import React from "react";
import { Col, Row } from "antd";
import { Smile, PieChart } from "react-feather";

import DisplayCard from "../../DisplayCard/DisplayCard";

const UserFeedback = () => {
  return (
    <div className="site-card-wrapper">
      <Row gutter={16}>
        <Col span={12} style={{ display: "flex" }}>
          <DisplayCard
            icon={<Smile strokeWidth={1} size={16} />}
            heading="INCOMING FEEDBACK"
            title="A permanent, real-time suggestion box on your site"
            description="A simple widget that lets users express frustration and delight—in the moment."
            buttonText="Create incoming feedback"
          />
        </Col>
        <Col span={12} style={{ display: "flex" }}>
          <DisplayCard
            icon={<PieChart strokeWidth={1} size={16} />}
            heading="SURVEYS"
            title="Validate issues and opportunities with Surveys"
            description=" Use a targeted survey to validate whether your users have the need you think they do."
            buttonText="Create Survey"
          />
        </Col>
      </Row>
    </div>
  );
};

export default UserFeedback;
